import React, { Fragment } from "react";

const DeviceDetails = props => {
  return props.data === undefined || props.data === null ? (
    <p className="mb-0">
      <b>Operating System:</b> {"-"}
      <br />
      <b>OS Version:</b> {"-"}
      <br />
    </p>
  ) : (
    <Fragment>
      {props.data.browser_name && (
        <p className="mb-0">
          <b>Operating System:</b> {props.data.device_model || "-"}
          <br />
          <b>OS Version:</b> {props.data.os_version || "-"}
          <br />
          <b>Browser Name:</b> {props.data.browser_name || "-"}
          <br />
          <b>Browser Version:</b> {props.data.app_version || "-"}
        </p>
      )}
      {!props.data.browser_name && (
        <p className="mb-0">
          <b>Device Model:</b> {props.data.device_model || "-"}
          <br />
          <b>Operating System:</b> {props.data.os_name || "-"}
          <br />
          <b>OS Version:</b> {props.data.os_version || "-"}
          <br />
          <b>App Version:</b> {props.data.app_version || "-"}
        </p>
      )}
    </Fragment>
  );
};

export default DeviceDetails;
